import store, { subscribe } from 'shared/store'
import { destroyModalAction } from 'shared/store/ducks/events'
import { actionNames } from 'shared/store/ducks/userSession'
import { LOGIN_MODAL_ID } from 'views/consts'

export default () => {
  subscribe.after(actionNames.setUserSession, ({ userSession }) => {
    const { isLoggedIn } = userSession
    if (isLoggedIn) {
      store.dispatch(destroyModalAction(LOGIN_MODAL_ID))
    }
  })
}
